import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CompareAssetModal } from 'views/FleetOverview/components/AssetCardsV2/modals/CompareModal';
import { useAppSelector } from 'store/hook';
import { selectAssociatedAssets } from 'store/asset.slice';
import { useTranslation } from 'react-i18next';

export const CompareAssetsWrapper = () => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(true);
  const assets = useAppSelector(selectAssociatedAssets);
  const navigate = useNavigate();

  const handleAbort = () => {
    setIsModalOpen(false);
    // Navigate back to fleet overview when modal is closed
    navigate('/fleet/summary');
  };

  return (
    <CompareAssetModal
      title={t('compare_assets')}
      open={isModalOpen}
      handleAbort={handleAbort}
      selectedAsset={[]}
      filteredAssets={assets}
    />
  );
};
